<template>
    <div class="flex size-12 shrink-0 items-center justify-center lg:size-16">
        <svg
            v-if="['Стрелка', 'Стрелка справа налево'].includes(type)"
            :class="{ 'rotate-180': type === 'Стрелка справа налево' }"
            class="h-full w-full transition-transform duration-300"
            viewBox="0 0 64 32"
            fill="none">
            <path
                d="M12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18V16V14ZM53.4142 17.4142C54.1953 16.6332 54.1953 15.3668 53.4142 14.5858L40.6863 1.85786C39.9052 1.07682 38.6389 1.07682 37.8579 1.85786C37.0768 2.63891 37.0768 3.90524 37.8579 4.68629L49.1716 16L37.8579 27.3137C37.0768 28.0948 37.0768 29.3611 37.8579 30.1421C38.6389 30.9232 39.9052 30.9232 40.6863 30.1421L53.4142 17.4142ZM12 16V18H52V16V14H12V16Z"
                fill="white"
                fill-opacity="0.4" />
            <path
                d="M0 4C3.1826 4 6.23485 5.26428 8.48528 7.51472C10.7357 9.76515 12 12.8174 12 16C12 19.1826 10.7357 22.2348 8.48528 24.4853C6.23485 26.7357 3.1826 28 0 28L0 16L0 4Z"
                fill="white"
                fill-opacity="0.2" />
        </svg>
        <div
            v-else-if="type === 'Плюс'"
            class="text-3xl font-light text-white/40">
            +
        </div>
        <div
            v-else
            class="h-[2px] w-8 bg-white/20"></div>
    </div>
</template>

<script setup lang="ts">
defineProps<{ type: string }>()
</script>
